import { Button, useI18nForm } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface Props {
	onClick: (locale: string) => void;
}

const Wrapper = styled.div`
	display: flex;
	justify-content: flex-end;
`;

export const DataFieldOpenOptionsButton: FC<Props> = ({ onClick }) => {
	const { t } = useTranslation();
	const { currentLanguage } = useI18nForm();

	const handleClick = useCallback(() => {
		onClick(currentLanguage);
	}, [currentLanguage, onClick]);

	return (
		<Wrapper>
			<Button type="button" size="small" onClick={handleClick}>
				{t("Open options")}
			</Button>
		</Wrapper>
	);
};
